<!--
Author: TangChen
Date: 2018-11-19
Desc: 适当性信息组件，由index.js 配置引入
-->
<template>
    <div class="comp-inv-info comp">
        <el-row class="acct-box two-cols-form">
            <el-form
                v-if="acctInfo.professionflag"
                ref="acctInfo"
                :model="acctInfo"
                :rules="rules"
                label-width="140px"
                class="acct-form"
                size="small"
                v-on:submit.native.prevent
            >
                <el-col :span="24">
                    <el-form-item label="投资者类型：" class="form-text">
                        <div class="text-con">
                            {{ $cache.getDict('120051', acctInfo.professionflag) }}
                        </div>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="普通投资者有效期：">
                        <div class="text-con">
                            长期
                        </div>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="实际控制人：" prop="actualisself" class="person-sel" :class="{'required':required}">
                        <el-radio-group v-model="acctInfo.actualisself">
                            <el-radio
                                v-for="item in person"
                                :key="item.id"
                                :label="item.id"
                            >{{ item.name }}
                            </el-radio>
                        </el-radio-group>
                        <!--<el-input
                            v-if="acctInfo.actualctrlname!=='本人'"
                            v-model.trim="acctInfo.actualctrlnameText"
                            placeholder="请输入实际控制人名称"
                            :maxlength="16"
                        />-->
                    </el-form-item>
                </el-col>
                <el-col v-if="acctInfo.actualisself === '0'" :span="24">
                    <el-form-item label="账户实际控制人：" prop="actualctrlname" :class="{'required':required}">
                        <el-input v-model.trim="acctInfo.actualctrlname" placeholder="请输入控制人姓名" :maxlength="20"/>
                    </el-form-item>
                </el-col>
                <el-col v-if="acctInfo.actualisself === '0'" :span="24">
                    <el-form-item label="控制人证件类型：" prop="actualctrlidtype" :class="{'required':required}">
                        <el-select v-model.trim="acctInfo.actualctrlidtype" placeholder="请选择控制人证件类型">
                            <el-option
                                v-for="item in actualctrlidtype"
                                :key="item.subitem"
                                :label="item.subitemname"
                                :value="item.subitem"
                            />
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col v-if="acctInfo.actualisself === '0'" :span="24">
                    <el-form-item label="控制人证件号码：" prop="actualctrlidcode" :class="{'required':required}">
                        <el-input v-model.trim="acctInfo.actualctrlidcode" placeholder="请输入控制人证件号码" :maxlength="32"/>
                    </el-form-item>
                </el-col>
                <el-col v-if="acctInfo.actualisself === '0'" :span="24">
                    <el-form-item label="控制人证件有效期：" prop="actualctrlvalidate" :class="{'required':required}">
                        <date-picker :date="dateSet" v-on:date-get="dateInterval"/>
                    </el-form-item>
                </el-col>
                <el-col v-if="acctInfo.actualisself === '0'" :span="24">
                    <el-form-item label="控制人联系地址：" prop="actualctrladdr" :class="{'required':required}">
                        <el-input v-model.trim="acctInfo.actualctrladdr" placeholder="例：XX省XX市XX区XX社区XX单元XXXX室"
                                  :maxlength="32"/>
                    </el-form-item>
                </el-col>
                <!-- <el-col :span="24">
                    <el-form-item label="实际受益人：" prop="beneficiary" class="person-sel" :class="{'required':required}">
                        <el-radio-group v-model="acctInfo.beneficiary" v-on:change="beneficiaryChange">
                            <el-radio
                                v-for="item in person"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                            />
                        </el-radio-group>
                        <el-input
                            v-if="acctInfo.beneficiary!=='本人'"
                            v-model.trim="acctInfo.beneficiaryText"
                            placeholder="请输入实际受益人名称"
                            :maxlength="16"
                        />
                    </el-form-item>
                </el-col> -->
                <el-col :span="24">
                    <div class="area-title">
                        财务状况
                    </div>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="年收入：" prop="annualincome" :class="{'required':required}">
                        <el-input
                            v-model.trim="acctInfo.annualincome"
                            placeholder="请输入年收入"
                            :disabled="riskLock.indexOf('annualincome')>-1"
                        />
                        <span class="text-con">&nbsp;元</span>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="收入来源：" prop="incomesource" :class="{'required':required}">
                        <el-select
                            v-model="acctInfo.incomesource"
                            filterable
                            placeholder="请选择收入来源"
                            :disabled="riskLock.indexOf('incomesource')>-1"
                        >
                            <el-option
                                v-for="item in incomesources"
                                :key="item.subitem"
                                :label="item.subitemname"
                                :value="item.subitem"
                            />
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="资产：" prop="assets" :class="{'required':required}">
                        <el-input
                            v-model.trim="acctInfo.assets"
                            placeholder="请输入资产"
                            :maxlength="16"
                            :disabled="riskLock.indexOf('assets')>-1"
                        />
                        <span class="text-con">&nbsp;元</span>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="债务：" prop="debt" :class="{'required':required}">
                        <el-select v-model="acctInfo.debt" filterable placeholder="请选择债务"
                                   :disabled="riskLock.indexOf('debt')>-1">
                            <el-option
                                v-for="item in debts"
                                :key="item.subitem"
                                :label="item.subitemname"
                                :value="item.subitem"
                            />
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <div class="area-title">
                        投资经验
                    </div>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="投资学习经历：" prop="investmentedu" :class="{'required':required}">
                        <el-select
                            v-model="acctInfo.investmentedu"
                            filterable
                            placeholder="请选择投资学习经历"
                            :disabled="riskLock.indexOf('investmentedu')>-1"
                        >
                            <el-option
                                v-for="item in investmentedus"
                                :key="item.subitem"
                                :label="item.subitemname"
                                :value="item.subitem"
                            />
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="投资工作经历：" prop="investmentwork" :class="{'required':required}">
                        <el-select
                            v-model="acctInfo.investmentwork"
                            filterable
                            placeholder="请选择投资工作经历"
                            :disabled="riskLock.indexOf('investmentwork')>-1"
                        >
                            <el-option
                                v-for="item in investmentworks"
                                :key="item.subitem"
                                :label="item.subitemname"
                                :value="item.subitem"
                            />
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="投资相关经验：" prop="investmentexp" :class="{'required':required}">
                        <el-select
                            v-model="acctInfo.investmentexp"
                            filterable
                            placeholder="请选择投资相关经验"
                            :disabled="riskLock.indexOf('investmentexp')>-1"
                        >
                            <el-option
                                v-for="item in investmentexps"
                                :key="item.subitem"
                                :label="item.subitemname"
                                :value="item.subitem"
                            />
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <div class="area-title">
                        投资目标及风险偏好
                    </div>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="投资期限：" prop="investmentterm" :class="{'required':required}">
                        <el-select
                            v-model="acctInfo.investmentterm"
                            filterable
                            placeholder="请选择投资期限"
                            :disabled="riskLock.indexOf('investmentterm')>-1"
                        >
                            <el-option
                                v-for="item in investmentterms"
                                :key="item.subitem"
                                :label="item.subitemname"
                                :value="item.subitem"
                            />
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="期望收益：" prop="execeptedearning" :class="{'required':required}">
                        <el-select
                            v-model="acctInfo.execeptedearning"
                            filterable
                            placeholder="请选择期望收益"
                            :disabled="riskLock.indexOf('execeptedearning')>-1"
                        >
                            <el-option
                                v-for="item in exceptedearnings"
                                :key="item.subitem"
                                :label="item.subitemname"
                                :value="item.subitem"
                            />
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="可承受损失：" prop="affordableloss" :class="{'required':required}">
                        <el-select
                            v-model="acctInfo.affordableloss"
                            filterable
                            placeholder="请选择可承受损失"
                            :disabled="riskLock.indexOf('affordableloss')>-1"
                        >
                            <el-option
                                v-for="item in affordableloss"
                                :key="item.subitem"
                                :label="item.subitemname"
                                :value="item.subitem"
                            />
                        </el-select>
                    </el-form-item>
                </el-col>
                <!-- <el-col :span="24">
                    <el-form-item label="职务：" prop="position" :class="{'required':required}">
                        <el-input
                            v-model.trim="acctInfo.position"
                            placeholder="请输入职务"
                            :maxlength="20"
                            :disabled="riskLock.indexOf('position')>-1"
                        />
                    </el-form-item>
                </el-col> -->
                <el-col :span="24">
                    <el-form-item label="投资品种：" prop="investfundtypeArr" :class="{'required':required}">
                        <el-checkbox-group
                            v-model="acctInfo.investfundtypeArr"
                            class="checkbox-list"
                            :disabled="riskLock.indexOf('investfundtype')>-1"
                        >
                            <el-checkbox v-for="item in investfundtypes" :key="item.subitem" :label="item.subitem">
                                {{ item.subitemname }}
                            </el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <div class="area-title">
                        其他
                    </div>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="诚信记录是否良好：" prop="creditrecord" class="person-sel"
                                  :class="{'required':required}">
                        <el-radio-group v-model="acctInfo.creditrecord" :disabled="riskLock.indexOf('creditrecord')>-1">
                            <el-radio
                                v-for="item in creditRecord"
                                :key="item.id"
                                :label="item.id"
                                :value="item.id"
                            >
                                {{ item.name }}
                            </el-radio>
                        </el-radio-group>
                        <el-input
                            v-if="acctInfo.creditrecord!=='1'"
                            v-model.trim="acctInfo.creditrecordText"
                            placeholder="请说明具体情况"
                            :maxlength="64"
                        />
                    </el-form-item>
                </el-col>
                <el-col v-if="isPwdCheck" :span="24">
                    <el-form-item label="交易密码：" prop="pwd" class="required">
                        <el-input
                            v-model.trim="acctInfo.pwd"
                            type="password"
                            placeholder="请输入交易密码"
                            :maxlength="16"
                        />
                        <span class="redemp-btn" v-on:click.prevent="$router.push({name: 'tradepwd'})"><span
                            class="like-a">忘记密码？</span></span>
                    </el-form-item>
                </el-col>
                <el-col :span="24" class="btn-group">
                    <el-button type="primary" class="medium" v-on:click="submitInfo('acctInfo')">
                        保存
                    </el-button>
                    <el-button class="medium" v-on:click="$router.back()">
                        返回
                    </el-button>
                </el-col>
            </el-form>
        </el-row>
        <el-dialog
            title="提示"
            :visible.sync="dialogVisible"
            width="50%"
            :close-on-click-modal="false"
        >
            <el-checkbox v-model="checked" class="check-style">
            </el-checkbox>
            <span>本人承诺，以上所填信息发生重大变化时，本人将主动、及时进行信息更新，以便于贵机构重新评估本人风险承受能力。如本人未进行前述更新导致的投资损失以及其他法律后果由本人自行承担。</span>
            <span slot="footer" class="dialog-footer">
                <el-button v-on:click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" :disabled="!checked" v-on:click="gotoSub()">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import datePicker from "@/components/form/datePicker.vue";
import format from "date-fns/format";

export default {
    name: "NavInvInfo",
    components: {
        datePicker
    },
    props: {
        fn: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            acctInfo: {pwd: "", actualctrlnameText: "", creditrecordText: ""},
            isPwdCheck: false,
            creditRecord: [{id: "1", name: "良好"}, {id: "2", name: "不良好"}],
            person: [{id: "1", name: "本人"}, {id: "0", name: "非本人"}],
            incomesources: [],
            debts: [],
            investmentedus: [],
            investmentworks: [],
            investmentexps: [],
            investmentterms: [],
            investfundtypes: [],
            exceptedearnings: [],
            affordableloss: [],
            actualctrlidtype: [],
            countrycode:[],
            machinecode:[],
            dateSet: {type: "3", max: "", dis: false},
            riskLock: "",
            required: false,
            query: null,
            dialogVisible: false,
            checked: false,
            rules: {
                actualctrlname: [
                    {validator: this.validateActualctrlname, trigger: "blur"}
                ],
                actualctrlidtype: [
                    {validator: this.validateActualctrlidtype, trigger: "change"}
                ],
                actualctrlidcode: [
                    {validator: this.validateActualctrlidcode, trigger: "blur"}
                ],
                actualctrlvalidate: [
                    {validator: this.validateActualctrlvalidate, trigger: "blur"}
                ],
                actualctrladdr: [
                    {validator: this.validateActualctrladdr, trigger: "blur"}
                ],
                /* beneficiary: [
                    { validator: this.paramRequired, mes: "实际受益人", trigger: "change" }
                ], */
                /*position: [
                    { validator: this.paramRequired, mes: "职务", trigger: "blur" }
                ],*/
                assets: [
                    {validator: this.assetsRequired, mes: "资产", trigger: "blur"}
                ],
                annualincome: [
                    {validator: this.selRequired, mes: "年收入", trigger: "change"}
                ],
                incomesource: [
                    {validator: this.selRequired, mes: "收入来源", trigger: "change"}
                ],
                debt: [
                    {validator: this.selRequired, mes: "债务", trigger: "change"}
                ],
                investmentedu: [
                    {validator: this.selRequired, mes: "投资学习经历", trigger: "change"}
                ],
                investmentwork: [
                    {validator: this.selRequired, mes: "投资工作经历", trigger: "change"}
                ],
                investmentexp: [
                    {validator: this.selRequired, mes: "投资相关经验", trigger: "change"}
                ],
                investmentterm: [
                    {validator: this.selRequired, mes: "投资期限", trigger: "change"}
                ],
                execeptedearning: [
                    {validator: this.selRequired, mes: "期望收益", trigger: "change"}
                ],
                affordableloss: [
                    {validator: this.selRequired, mes: "可承受损失", trigger: "change"}
                ],
                creditrecord: [
                    {validator: this.paramRequired, mes: "诚信记录", trigger: "change"}
                ],
                investfundtypeArr: [
                    {validator: this.selRequired, mes: "投资品种", trigger: "change"}
                ],
                pwd: [
                    {required: true, message: "请输入交易密码", trigger: "blur"}
                ]
            }
        };
    },
    watch: {
        "acctInfo.assets"(val) {
            this.isAmount(val);
        },
        "acctInfo.actualisself"(val) {
            if (val === '1') {
                this.acctInfo.actualctrlname = "";
                this.acctInfo.actualctrlidtype = "";
                this.acctInfo.actualctrlidcode = "";
                this.acctInfo.actualctrlvalidate = "";
                this.acctInfo.actualctrladdr = "";
                this.$set(this.dateSet, "val", "");
                this.$set(this.dateSet, "time", new Date().getTime());
            }
        },
        "acctInfo.creditrecord"(val) {
            if (val === '1') {
                this.acctInfo.creditrecordText = ""
            }
        }
    },
    created() {
        this.getCollectionInfo();
        this.isPwdCheck = this.$cache.getPwdCheck("B1");
        // 初始化数据字典值
        this.incomesources = this.$cache.getDict("120073");
        this.debts = this.$cache.getDict("150064");
        this.investmentedus = this.$cache.getDict("150067");
        this.investmentworks = this.$cache.getDict("150068");
        this.investmentexps = this.$cache.getDict("150069");
        this.investmentterms = this.$cache.getDict("150071");
        this.investfundtypes = this.$cache.getDict("150072");
        this.exceptedearnings = this.$cache.getDict("150073");
        this.affordableloss = this.$cache.getDict("150075");
        this.actualctrlidtype = this.$cache.getDict("130007");
        this.countrycode = this.$cache.getDict("150136");
        this.machinecode = this.$cache.getDict("150137");

        this.dateSet.max = this.$util.fmtDate(this.$util.getConfig().const.CARD_DATE_MAX);
        this.$set(this.dateSet, "val", "");
        this.$set(this.dateSet, "time", new Date().getTime());
    },
    methods: {
        dateInterval(val) {
            this.acctInfo.actualctrlvalidate = val !== null ? val.replace(/-/g, "") : "";
            this.$refs.acctInfo.validateField("actualctrlvalidate");
        },
        gotoSub() {
            const _this = this;
            _this.dialogVisible = false;
            // 数据合并提交
            if (_this.acctInfo.investfundtypeArr.length && _this.acctInfo.investfundtypeArr.length > 0) {
                _this.acctInfo.investfundtype = _this.acctInfo.investfundtypeArr.join(",");
            } else {
                _this.acctInfo.investfundtype = "";
            }
            let _x = Object.assign({}, _this.acctInfo);
            /*if (_x.actualctrlname !== "本人") {
                _x.actualctrlname = _x.actualctrlnameText;
            }*/
            /* if (_x.beneficiary !== "本人") {
                        _x.beneficiary = _x.beneficiaryText;
                    } */
            if (_x.creditrecord !== "1") {
                _x.creditrecord = _x.creditrecordText;
            }
            _x.tradepwd = this.$util.enc(_x.pwd);
            delete _x.investfundtypeArr;
            delete _x.pwd;
            _this.$util.request("acct/sdx/info", _x, "PUT").then(res => {
                if (res.data) {
                    const info = _this.$cache.getUser();
                    _this.$store.dispatch("setInfo", info).then(() => {
                        /* _this.$message({
                            type: "success",
                            message: "适当性信息已更新成功" + (_this.fn ? "" : "，3秒后回到个人信息页面"),
                            onClose: function () {
                                if (_this.fn) { _this.$emit("fn-back", true); } else {
                                    _this.$router.push({ name: "info" });
                                }
                            }
                        }); */
                        _this.$cache.refreshUser();
                        _this.$message({
                            type: "success",
                            message: "适当性信息已更新成功",
                            onClose: function () {
                                if (_this.fn) {
                                    _this.$emit("fn-back", true);
                                }
                            }
                        });
                        // 暂时屏蔽投资者转换入口
                        /* if (Number(_this.acctInfo.assets) >= 500) {
                            _this.getInvestor();
                        } */
                    });
                }
            });
        },
        /* 提交表单数据，校验用户信息 */
        submitInfo(formName) {
            const _this = this;
            _this.$refs[formName].validate(valid => {
                if (valid) {
                    _this.dialogVisible = true;
                } else {
                    return false;
                }
            });
        },
        // 文字字母校验
        paramRequired(rule, value, callback) {
            if (rule.field === "creditrecord") {
                if (this.acctInfo.creditrecord === "2") {
                    this.$util.validateGeneral(rule, this.acctInfo[rule.field + "Text"], callback, rule.mes);
                } else {
                    callback();
                }
            } else {
                if (this.riskLock.indexOf(rule.field) === -1 && (this.required || value.trim() !== "")) {
                    this.$util.validateGeneral(rule, value, callback, rule.mes);
                } else {
                    callback();
                }
            }
        },
        validateActualctrlname(rule, value, callback) {
            if (this.acctInfo.actualisself === "0") {
                if (this.$util.isEmpty(value)) {
                    callback(new Error("请输入控制人姓名"));
                } else {
                    callback();
                }
            } else {
                callback();
            }
        },
        validateActualctrlidtype(rule, value, callback) {
            if (this.acctInfo.actualisself === "0") {
                if (this.$util.isEmpty(value)) {
                    callback(new Error("请选择控制人证件类型"));
                } else {
                    callback();
                }
            } else {
                callback();
            }
        },
        validateActualctrlidcode(rule, value, callback) {
            if (this.acctInfo.actualisself === "0") {
                if (this.$util.isEmpty(value)) {
                    callback(new Error("请输入控制人证件号码"));
                } else {
                    this.$util.validateCertNo(rule, value, callback, this.acctInfo.actualctrlidtype);
                }
            } else {
                callback();
            }
        },
        validateActualctrlvalidate(rule, value, callback) {
            if (this.acctInfo.actualisself === "0") {
                if (this.$util.isEmpty(value)) {
                    callback(new Error("请选择控制人证件有效期"));
                } else {
                    callback();
                }
            } else {
                callback();
            }
        },
        validateActualctrladdr(rule, value, callback) {
            if (this.acctInfo.actualisself === "0" && !value) {
                callback(new Error("请输入控制人联系地址"));
            } else {
                callback();
            }
        },
        // 资产校验
        assetsRequired(rule, value, callback) {
            if (this.riskLock.indexOf(rule.field) === -1 && (this.required || value.trim() !== "")) {
                this.$util.validateDecimal(rule, value, callback);
            } else {
                callback();
            }
        },
        // 资产校验
        selRequired(rule, value, callback) {
            if (this.riskLock.indexOf(rule.field) === -1 && (this.required && ((rule.field !== "investfundtypeArr" && value.trim() === "") || (rule.field === "investfundtypeArr" && value.length === 0)))) {
                callback(new Error("请选择" + rule.mes));
            } else {
                callback();
            }
        },
        isAmount(val) {
            const _val = this.$util.checkAmount(val);
            clearTimeout(this.query);
            this.query = setTimeout(() => {
                this.$set(this.acctInfo, "assets", _val);
            }, 1);
        },
        getCollectionInfo() {
            const _this = this;
            this.$util.request("acct/sdx/info").then(res => {
                if (res.data) {
                    const _a = res.data[0][0];
                    for (let item in _a) {
                        _a[item] = _a[item].trim();
                    }
                    // 数据初始化转换
                    /*if (_a.actualctrlname !== "本人") {
                        _a.actualctrlnameText = _a.actualctrlname;
                        _a.actualctrlname = _a.actualctrlname ? "非本人" : "本人";
                    }*/
                    /* if (_a.beneficiary !== "本人") {
                        _a.beneficiaryText = _a.beneficiary;
                        _a.beneficiary = _a.beneficiary ? "非本人" : "本人";
                    } */
                    if (_a.creditrecord != "1" && _a.creditrecord.trim() != "") {// 如果信用不良好，则回显不良好备注，并且回显单选框状态
                        _a.creditrecordText = _a.creditrecord;
                        _a.creditrecord = "2";
                    }else{
                        _a.creditrecord = "1";
                    }
                    if (_a.investfundtype.indexOf(",") > -1) {
                        _a.investfundtypeArr = _a.investfundtype.split(",");
                    } else {
                        _a.investfundtypeArr = [];
                        if (_a.investfundtype) {
                            _a.investfundtypeArr.push(_a.investfundtype);
                        }
                    }
                    _this.acctInfo = Object.assign({}, _this.acctInfo, _a || {});
                    _this.acctInfo.actualisself = (_a.actualisself && _a.actualisself.trim()) || "1";
                    this.dateSet.max = this.$util.fmtDate(this.$util.getConfig().const.CARD_DATE_MAX);
                    this.$set(this.dateSet, "val", format(_a.actualctrlvalidate, "YYYY-MM-DD"));
                    this.$set(this.dateSet, "time", new Date().getTime());
                    _this.required = res.data[1][0].isrequired === "1";
                    _this.riskLock = res.data[1][0].fieldfromrisk;
                    if (_this.riskLock.indexOf("investfundtype") > -1) {
                        _this.riskLock += ",investfundtypeArr";
                    }
                    if (_this.riskLock.indexOf("credit") > -1) {
                        _this.riskLock += ",creditrecord";
                    }
                }
            });
        },
        // 获取投资者转换信息
        getInvestor() {
            const _this = this;
            this.$util.request("acct/changetype/suitableinfo").then(res => {
                if (res.data) {
                    if (res.data[0].professionflag === "0" && res.data[0].appstatus !== "1" && res.data[0].appstatus !== "2") {
                        _this.$confirm("根据您所提交的投资者资料确认您符合专业投资者认定标准，是否立即前往转换为专业投资者？", "温馨提示", {
                            confirmButtonText: "前往转换",
                            cancelButtonText: "暂不转换",
                            type: "info"
                        }).then(() => {
                            _this.$router.push({name: "invchange"});
                        });
                    }
                }
            });
        },
        actualctrlnameChange(val) {
            if (val === "本人") this.$refs.acctInfo.validateField("actualctrlname");
        }/* ,
        beneficiaryChange (val) {
            if (val === "本人") this.$refs.acctInfo.validateField("beneficiary");
        } */
    }
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";

.comp-inv-info {
    .el-col.el-col-12 {
        height: 51px;
        overflow: hidden;
    }

    .acct-box {
        padding: 20px 160px;

        .el-select {
            width: 79%;

            .el-input {
                width: 100%;
            }
        }

        .el-input,
        .el-textarea {
            width: 79%;
        }

        .person-sel {
            .el-radio + .el-radio {
                margin-left: 20px;
            }

            .el-input {
                width: 40%;
                margin-left: 10px;
            }
        }

        .area-title {
            padding: 8px 0px;
            font-size: 16px;
            line-height: 16px;
            border-bottom: 1px solid #ebebeb;
            color: rgb(0, 142, 223);
            margin-bottom: 10px;
        }
    }

    .check-style {
        margin-right: 10px;
    }
}
</style>
